// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ddc13146","453":"5d141c58","796":"9d427ee7"}[chunkId] + ".chunk.js";
};